import {
  Text,
  Button,
  HStack,
  VStack,
  Box,
  Divider,
} from '@cdl/heartbeat-react';

import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { addNewAnnotationTask } from '../thunks/add-new-annotation-task.thunks';
import { Link } from 'react-router-dom';
import { AnnotatorsForm } from './newtask/AnnotatorsForm';
import { HoneypotForm } from './newtask/HoneypotForm';
import { ProjectForm } from './newtask/ProjectForm';
import { SettingsForm } from './newtask/SettingsForm';
import { GeneralDataForm } from './newtask/GeneralDataForm';
import {
  defaultPTags,
  defaultQrsTags,
  FormValues,
  waveTypes,
} from '../types/annotation-task-detail.type';

export const TaskForm = () => {
  const dispatch = useDispatch();

  const {
    handleSubmit,
    register,
    setValue,
    control,
    getValues,
    resetField,
    formState: { isSubmitting, isValid },
  } = useForm<FormValues>({
    defaultValues: {
      name: '',
      priority: '',
      nb_annotations: '',
      dataset_id: '',
      annotators: [],
      description: '',
      annotation_grid: '',
      honeypot_dataset_id: '',
      honeypot_probability: '',
      project_id: '',
      settings: {
        platane_annotation_settings: {
          waves_to_display: Object.fromEntries(
            waveTypes.map((tag) => [tag, true]),
          ),
          waves_to_annotate: Object.fromEntries(
            waveTypes.map((tag) => [tag, true]),
          ),
          tags_to_display: {
            P: defaultPTags,
            QRS: defaultQrsTags,
          },
          tags_to_annotate: {
            P: defaultPTags,
            QRS: defaultQrsTags,
          },
        },
      },
    },
  });

  const onSubmit = async (values: FormValues) => {
    await dispatch(addNewAnnotationTask(values));
  };

  return (
    <VStack alignItems='stretch' gap={4}>
      <Box mb='s'>
        <HStack fontSize='xs' color='neutral.400'>
          <Text as='u'>
            <Link to={'/admin/dashboard'}>Dashboard</Link>
          </Text>
        </HStack>
        <Text mt='s' mb='xl' textStyle='page-title'>
          Create new annotation task
        </Text>
      </Box>

      <form onSubmit={handleSubmit(onSubmit)}>
        <GeneralDataForm
          register={register}
          setValue={setValue}
          control={control}
          resetField={resetField}
        />
        <Divider mb='m' />
        <AnnotatorsForm
          register={register}
          setValue={setValue}
          control={control}
        />
        <Divider mb='m' />
        <HoneypotForm
          register={register}
          setValue={setValue}
          control={control}
          resetField={resetField}
        />
        <Divider mb='m' />
        <ProjectForm
          register={register}
          setValue={setValue}
          resetField={resetField}
          control={control}
        />
        <Divider mb='m' />
        <SettingsForm
          control={control}
          setValue={setValue}
          resetField={resetField}
          getValues={getValues}
        />

        <Button
          isLoading={isSubmitting}
          type='submit'
          mt='xl'
          float='right'
          isDisabled={!isValid}
        >
          Submit
        </Button>
      </form>
    </VStack>
  );
};
